export const URL_CTA_NODE_TYPE = "url_cta";
export const URL_CTA_SCHEMA_VERSION = 1;

export const URL_CTA_AFTER_SEND = Object.freeze({
  CONTINUE: "continue",
  END: "end",
});

export const createUrlCtaConfig = () => ({
  schemaVersion: URL_CTA_SCHEMA_VERSION,
  body: "",
  buttonLabel: "Visit Website",
  url: "",
  afterSend: URL_CTA_AFTER_SEND.CONTINUE,
});

const parseHttpsUrl = value => {
  const trimmedValue = typeof value === "string" ? value.trim() : "";
  if (!trimmedValue) return null;
  try {
    const parsedUrl = new URL(trimmedValue);
    if (
      parsedUrl.protocol !== "https:" ||
      !parsedUrl.hostname ||
      parsedUrl.username ||
      parsedUrl.password
    ) return null;
    return parsedUrl;
  } catch {
    return null;
  }
};

export const validateUrlCtaConfig = config => {
  const errors = {};
  if (config?.schemaVersion !== URL_CTA_SCHEMA_VERSION) {
    errors.schemaVersion = "URL Node configuration version is unsupported.";
  }
  if (!config?.body?.trim()) errors.body = "Message text is required.";
  if (!config?.buttonLabel?.trim()) errors.buttonLabel = "Button label is required.";
  if (!parseHttpsUrl(config?.url)) errors.url = "Website URL must be an absolute HTTPS URL.";
  if (!Object.values(URL_CTA_AFTER_SEND).includes(config?.afterSend)) {
    errors.afterSend = "After sending must be Continue or End.";
  }
  const messages = Object.values(errors);
  return { isValid: messages.length === 0, errors, message: messages[0] || "" };
};

export const normalizeUrlCtaConfig = config => ({
  schemaVersion: URL_CTA_SCHEMA_VERSION,
  body: config?.body?.trim() || "",
  buttonLabel: config?.buttonLabel?.trim() || "",
  url: config?.url?.trim() || "",
  afterSend: config?.afterSend,
});

export const getUrlCtaHostname = value => parseHttpsUrl(value)?.hostname || "";
